const enum ViewStyle {
  GRID = 'grid',
  TABLE = 'table',
}

export { ViewStyle };
